import { Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Injectable()
export class ControlService {

	public setFocus(control: string): boolean {
		let element = document.getElementById(control);

		if (element !== null) {

			element.focus();

			return true;
		}

		return false;
	}

	public setFocusFirstControl(formGroup: FormGroup) {
		let focusSuccess = false;

		if (formGroup !== undefined && formGroup.controls !== null) {
			let controlName = Object.keys(formGroup.controls).forEach((controlName) => {

				if (focusSuccess === false && this.setFocus(controlName)) {
					focusSuccess = true;
				}
			});
		}
	}

	public setFocusFirstControlInvalid(formGroup: FormGroup) {
		let firstControl: string;

		Object.keys(formGroup.controls).map((controlName) => {
			if (firstControl === undefined && formGroup.get(controlName).invalid) {
				firstControl = controlName;
			}
		});

		if (firstControl !== undefined) {
			this.setFocus(firstControl);
		}
	}

	public focusNextControl(formGroup: FormGroup, lastControlFocus: string, sameGroup: boolean = true): boolean {

		let nextControl: any = [];
		nextControl.getNext = false;
		nextControl.theEnd = false;
		nextControl.targetElement = undefined;
		nextControl.success = false;
		nextControl.parent = '';

		this.focusNextControlInternal(formGroup, lastControlFocus, nextControl, '', sameGroup);

		if (nextControl.success === true) {
			return true;
		} else {
			this.setFocusFirstControl(formGroup);

			return true;
		}
	}

	private focusNextControlInternal(formGroup: FormGroup, lastControlFocus: string, nextControl: any, parent: string, sameGroup: boolean) {
		Object.keys(formGroup.controls).forEach((thisControlName) => {

			if (nextControl.theEnd === false) {

				let control = formGroup.get(thisControlName);

				if (control !== null && control.disabled === false) {

					if (nextControl.getNext === true && (sameGroup === true || (sameGroup === false && parent !== nextControl.parent))) {

						if (control instanceof FormControl) {
							nextControl.targetElement = document.getElementById(parent + thisControlName);

							if (nextControl.targetElement !== null) {

								nextControl.theEnd = true;
								this.setFocus(parent + thisControlName);
								nextControl.success = true;
								return;

							}
						} else if (control instanceof FormGroup) {
							this.focusNextControlInternal(control, lastControlFocus, nextControl, thisControlName + '.', sameGroup);
						}
					} else if (nextControl.theEnd === false) {
						if (control instanceof FormControl) {
							if (parent + thisControlName === lastControlFocus) {

								nextControl.parent = parent;
								nextControl.getNext = true;

							}
						} else if (control instanceof FormGroup) {
							this.focusNextControlInternal(control, lastControlFocus, nextControl, thisControlName + '.', sameGroup);
						}
					}
				}
			}
		});

		return false;
	}

	public markAllTouched(formGroup: FormGroup, exclude: any[] = []) {
		this.markTouched('', formGroup.controls, formGroup, exclude);
	}

	private markTouched(parent, controls, formGroup: FormGroup, exclude: any[]) {

		Object.keys(controls).map((controlName) => {
			let findControl = (parent === '' ? '' : parent + '.') + controlName;

			let control = formGroup.get(findControl);

			if (control !== null && control instanceof FormControl && exclude.find((x) => x === findControl) === undefined) {
				control.markAsTouched({ onlySelf: true });
				control.markAsDirty({ onlySelf: true });
			} else if (control !== null && control instanceof FormGroup) {
				this.markTouched(controlName, control.controls, formGroup, exclude);
			}
		});

	}
}